export function label(ctx) {
    const { bg_color, bg_opa, border_color, border_width, ...labelPretty } = ctx.pretty;
    return {
        styles: {
            main: { ...labelPretty, text_font: 32, text_letter_space: 0, text_decor: 0 },
        },
    };
}
